export const en = {
    confirmation: 'Confirmation',
    hotel_name: 'Hotel name',
    hotel_type: 'Hotel type',
    price_per_night: 'Price per night',
    recommended: 'Recommended',
    stars_count: 'Stars',
};
